import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Button, Col, Divider, Row } from "antd";
import ConsignmentReusablePackagingTable from "../ConsignmentReusablePackagingTable";
import ConsignmentReusablePackagingEditModal from "../ConsignmentReusablePackagingEditModal";
const ReusablePackagingStep = ({ active, tenantId, consignmentPackagings, onChange, onBack, onSubmit }) => {
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [editingIndex, setEditingIndex] = useState(-1);
    const [editingReusablePackaging, setEditingReusablePackaging] = useState(null);
    const add = () => {
        setEditModalVisible(true);
        setEditingIndex(-1);
        setEditingReusablePackaging(null);
    };
    const edit = (editingReusablePackaging, index) => {
        setEditModalVisible(true);
        setEditingIndex(index);
        setEditingReusablePackaging(editingReusablePackaging);
    };
    const remove = (reusablePackaging) => {
        onChange(consignmentPackagings.filter(rp => rp.id != reusablePackaging.id));
    };
    const hideEditModal = () => {
        setEditModalVisible(false);
        setEditingIndex(-1);
        setEditingReusablePackaging(null);
    };
    const onSave = (formValues, selectedReusablePackaging, selectedSenderReceiver) => {
        const updatedPackagings = [...consignmentPackagings];
        const newReusablePackaging = {
            id: editingReusablePackaging ? editingReusablePackaging.id : 0,
            version: editingReusablePackaging ? editingReusablePackaging.version : 0,
            actualPickupQuantity: editingReusablePackaging ? editingReusablePackaging.actualPickupQuantity : 0,
            actualDropQuantity: editingReusablePackaging ? editingReusablePackaging.actualDropQuantity : 0,
            reusablePackaging: selectedReusablePackaging,
            scheduledDropQuantity: formValues.scheduledDropQuantity,
            scheduledPickupQuantity: formValues.scheduledPickupQuantity,
            returnToSenderReceiver: selectedSenderReceiver
        };
        if (editingIndex >= 0) {
            updatedPackagings[editingIndex] = newReusablePackaging;
        }
        else {
            updatedPackagings.push(newReusablePackaging);
        }
        onChange(updatedPackagings);
        hideEditModal();
    };
    if (!active) {
        return null;
    }
    return (_jsxs("div", { children: [_jsxs(Row, { gutter: 10, className: "no-margin", children: [" ", _jsx("p", { children: "\u00A0" }), _jsxs(Col, { xs: 24, children: [_jsx("p", { children: _jsx(Button, { onClick: add, children: "Add Reusable Packaging" }) }), _jsx(ConsignmentReusablePackagingTable, { reusablePackagings: consignmentPackagings, hasActions: true, renderActions: (reusablePackaging, index) => (_jsxs("span", { children: [_jsx(Button, { size: "small", onClick: () => edit(reusablePackaging, index), children: "Edit" }), _jsx(Divider, { orientation: "vertical" }), _jsx(Button, { size: "small", onClick: () => remove(reusablePackaging), children: "Remove" })] })) })] })] }), _jsx("p", { children: "\u00A0" }), _jsx(Row, { children: _jsxs(Col, { xs: 24, children: [_jsx(Button, { type: "default", htmlType: "button", size: "large", onClick: onBack, children: "\u00AB Back" }), _jsx(Button, { className: "pull-right", type: "primary", htmlType: "button", size: "large", onClick: () => onSubmit(false), children: "Create Delivery" }), _jsx(Button, { className: "pull-right", type: "default", htmlType: "button", size: "large", style: { marginRight: '12px' }, onClick: () => onSubmit(true), children: "Create and Post on Marketplace" })] }) }), _jsx(ConsignmentReusablePackagingEditModal, { tenantId: tenantId, showSpinner: false, open: editModalVisible, editingReusablePackaging: editingReusablePackaging, onCancel: hideEditModal, onSave: onSave })] }));
};
export default ReusablePackagingStep;
